<template>
  <div>
    <el-row>
      <el-card class="box-card">
        <span>投入计划</span>
        <div style="float: right"></div>
      </el-card>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="employListbox">
          <el-row :gutter="10" style="margin-left: 0px">
            <el-button type="primary" size="small" icon="el-icon-upload">
              导出
            </el-button>

            <el-select
              v-model="inputType"
              filterable
              size="small"
              placeholder="根据投入品类型查询"
              @change="inputTypeChoose"
            >
              <el-option
                v-for="(item, index) in inputTypeOption"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="inputId"
              filterable
              size="small"
              placeholder="根据投入品名称查询"
            >
              <el-option
                v-for="(item, index) in inputsOption"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="time"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              range-separator="至"
              start-placeholder="计划范围开始日期"
              end-placeholder="计划范围结束日期"

            >
            </el-date-picker>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="searchData"
            >
              搜索
            </el-button>
          </el-row>
<!--          <el-row v-if="tableData.length == 0">-->
<!--            <el-row style="text-align:center">-->
<!--              <span>暂无数据</span>-->
<!--            </el-row>-->
<!--          </el-row>-->
          <el-row >

            <el-row :gutter="20">
              <el-col :span="5">
                <div class="title-box">
                  <span class="left-title"> 投入品:</span>
                  <span>{{name}}</span>
                </div>
                <div class="title-box">
                  <span class="left-title">总量:</span>
                  <span>{{sum}}</span>

                </div>
                <div class="title-box">
                  <span class="left-title">时间段:</span>
                  <span v-if="time">
                    <span>{{new Date(time[0]).format('yyyy-MM-dd')}}</span> 至
                    <span>{{new Date(time[1]).format('yyyy-MM-dd')}}</span>
                  </span>
                </div>
              </el-col>
              <el-col :span="19">
                <div id="main" style="width: 100%;height: 500px"></div>
              </el-col>

            </el-row>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  import { getDataByEnterpriseId } from '@/api/inputs-invoice.js'
import { getInputData, deletetInput,inputsByType,inputsPlan } from '@/api/input-plan.js'
export default {
  name: 'Plant',
  components: {},
  data() {
    return {
      inputId: undefined,
      inputType:"",
      pageNum: 1,
      value: 10,
      total: 0,
      searchContent: null,
      activate: '3-3',
      tableData: [],
      activeTab: 'newone',
      enterpriseId: 1,
      inputsOption:[],
      inputs:[],
      inputTypeOption:[
        {
          label:'农药',
          value:'农药'
        },
        {
          label:'化肥',
          value:'化肥'
        }
      ],
      time:null,
      chartDom:null,
      myChart:null,
      sum:'',
      name:'',
    }
  },
  computed: {
    title: function () {
      return this.inputId ? '编辑' : '新增'
    },
  },
  methods: {
    inputShow(name,date,num) {
      let myChart = echarts.getInstanceByDom(document.getElementById("main"))
      if (myChart == null) { // 如果不存在，就进行初始化
        myChart = echarts.init(document.getElementById("main"));
      }
      var option;
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: date,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: name,
            type: 'bar',
            data: num
          },
        ]
      };
      option && myChart.setOption(option);
    },
    inputTypeChoose() {
      this.getInputsByType()
    },
    cancel() {
      // this.$refs.inputAdd.clearFrom()
      // this.plantId=undefined
    },
    editor(row) {
      this.inputId = row.id
      Object.keys(this.$refs.inputAdd.form).forEach((key) => {
        this.$refs.inputAdd.form[key] = row[key]
      })
    },
    /**
     * 跳转到新增投入品计划还是编辑投入品计划
     */
    addOrEdit(val) {
      if (val === 'new') {
        this.$router.push('inputs-add')
      }
    },
    showactivate(a) {
      this.activate = a
      //  (this.activate = a)
    },
    getInputsByType() {
      inputsByType(this.$store.getters.currentEnterprise.id,this.inputType).then(data=>{
        this.inputsOption = data.data.map((item) => {
          return {
            id:item.inputId,
            ...item,
          }
        })
      })
    },
    getAllInputs() {
      let option={
        pageNum:1,
        pageSize:0
      }
      getDataByEnterpriseId(this.$store.getters.currentEnterprise.id,option).then((r) => {
        this.total = r.data.total
        this.inputsOption = r.data.list
        this.inputs=r.data.list
      })
    },
    searchData() {
      if(!this.time||!this.inputId){
        this.$message.error("投入品和时间段都不能为空")
        return
      }
      let option={
        enterpriseId: this.$store.getters.currentEnterprise.id,
        inputId:this.inputId,
      }
      if(this.time) {
        option.startTime=this.time[0]
        option.endTime=this.time[1]
      }
      inputsPlan(option).then(data=>{
        console.log(data)
        let name=this.inputsOption.find(item=>item.inputId==this.inputId).name
        let date=[]
        let num=[]
        let i=0
        let packingForm=this.inputs.find(item=>item.id==this.inputId).packagingForm
        data.data.forEach(item=>{
          date.push(item.time)
          num.push(item.volumn)
          if(item.volumn){
            i+=item.volumn
          }
        })
        this.sum=i+packingForm
        this.name=name
        this.inputShow(name,date,num)
      })
    }
  },
  filters: {
    timeString: function (t) {
      let d = new Date(t)
      let month = d.getMonth() + 1 < 9 ? `0${d.getMonth() + 1}` : d.getMonth()
      let day = d.getDate() + 1 < 10 ? `0${d.getDate()}` : d.getDate()
      let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours()
      let minutes = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()
      let second = d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds()
      return `${d.getFullYear()}-${month}-${day}`
    },
    stauusString(value) {
      if (value == 0) {
        return '待处理'
      } else if (value == 1) {
        return '已完成'
      }
    },
  },
  mounted() {
    this.inputShow()
    this.getAllInputs()

  },
  beforeDestroy() {},
}
</script>

<style scoped>
.employListbox {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  min-height: 603px;
}
.left-title {
  display: inline-block;
  width: 70px;
  text-align: right;
  margin-right: 4px;
}
.title-box{
  margin-top: 8px;
}
.cardTitle {
  margin-top: 0px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/plan/Inputs.vue